<template>
  <div class="big health-refund-record">
    <div class="page_title flex_between">
      <span>退款记录</span>
      <el-button type="primary" style="width: 120px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="search_box">
          <div class="item">
            <span class="itemtitle">用户手机号</span>
            <el-input
              v-model="searchForm.phone"
              clearable
              style="width: 180px"
              size="small"
              maxlength="30"
              placeholder="请输入"
              @change="search"
            ></el-input>
          </div>

          <div class="item">
            <span class="itemtitle">支付时间</span>
            <el-date-picker
              v-model="searchForm.pay_time"
              type="daterange"
              align="right"
              size="small"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 230px"
              @change="search"
            >
            </el-date-picker>
          </div>

          <div class="item">
            <span class="itemtitle">退款时间</span>
            <el-date-picker
              v-model="searchForm.refund_time"
              type="daterange"
              align="right"
              size="small"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 230px"
              @change="search"
            >
            </el-date-picker>
          </div>

          <div class="item">
            <el-button
              type="primary"
              style="margin-left: 20px"
              size="small"
              @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :align="item.align"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'refund_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'buy_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'cancel_welfare'">
                  {{ scope.row[item.prop] | cancel_welfare_text }}
                </div>

                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>
  
  <script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tableLoading: false,
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      searchForm: {
        phone: "",
        pay_time: "",
        refund_time: "",
      },
      tableHeader: [
        {
          label: "退款时间",
          prop: "refund_time",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "购买记录ID",
          prop: "log_id",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "用户昵称",
          prop: "nick_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "用户手机号",
          prop: "phone",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "购买时间",
          prop: "buy_time",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "退款金额",
          prop: "refund_money",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "是否取消养生卡福利",
          prop: "cancel_welfare",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "备注",
          prop: "remark",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    cancel_welfare_text(val) {
      switch (val) {
        case 0:
          return "否";
        case 1:
          return "是";
        case 2:
          return "已过期";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      let params = Object.assign({}, this.searchForm, this.pagination);
      params = _.omit(params, ["pay_time", "refund_time"]);

      let pay_time = this.searchForm.pay_time;
      params.pay_start_time = pay_time ? pay_time[0] : "";
      params.pay_end_time = pay_time ? pay_time[1] : "";

      let refund_time = this.searchForm.refund_time;
      params.refund_start_time = refund_time ? refund_time[0] : "";
      params.refund_end_time = refund_time ? refund_time[1] : "";

      marketing
        .healthcardRefundRecord(params)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    },
    back() {
      history.back();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.search_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  .item {
    height: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .itemtitle {
      display: inline-block;
      width: 80px;
      margin-right: 8px;
      text-align: right;
    }
  }
}
</style>
  